import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFamiliesChartsDataContext } from './hooks/useFamiliesChartsDataContext';

export const AveragePeoplePerFamily = () => {
    const { chartData } = useFamiliesChartsDataContext();


    return (
        <SimpleBars
            title={'Média de Pessoas por Família'}
            horizontal={true}
            subtitles={chartData?.averagePeoplePerFamily?.map((item) => item.description)}
            values={chartData?.averagePeoplePerFamily?.map((item) => item.total  ||  0)}
        />
    );
};

